import Pusher from 'pusher-js';
import { COUNTRY_CONFIG } from 'Douleutaras/constants/localization';
import { useLocalization } from 'Douleutaras/hooks/localization';

const PUSHER_APP_KEY = process.env.PUSHER_APP_KEY;
const PUSHER_APP_CLUSTER = 'eu'; // hardcoded, as its unlikely to change

const API_URL = COUNTRY_CONFIG.API_URL[(useLocalization()).countryCode];

export const pusherInitializer = ({ jwtToken }: { jwtToken: string }) => new Pusher(PUSHER_APP_KEY, {
  cluster: PUSHER_APP_CLUSTER,
  authEndpoint: `${API_URL}pusher/auth/`,
  auth: {
    headers: {
      Authorization: `JWT ${jwtToken}`
    }
  }

});
